<script setup lang="ts">
import type { ChartComponentRef } from 'vue-chartjs'
import { Line as lineChart } from 'vue-chartjs'
import type { ChartOptions } from 'chart.js'
import {
	CategoryScale,
	Chart as ChartJS,
	Legend,
	LineElement,
	LinearScale,
	PointElement,
	TimeScale,
	Title,
	Tooltip,
} from 'chart.js'
import 'chartjs-adapter-date-fns'

const props = defineProps<{
	chartData: App.Data.ScrapeItem.Chart.ChartData
}>()

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	TimeScale,
)

const chart = ref<ChartComponentRef | null>(null)

const chartOptions = ref<ChartOptions>({
	responsive: true,
	maintainAspectRatio: true,
	scales: {
		x: {
			type: 'time',
			time: {
				unit: 'day',
				tooltipFormat: 'dd-MM-yyyy',
			},
			title: {
				display: true,
				text: 'Date',
			},
		},
		y: {
			title: {
				display: true,
				text: 'value',
			},
		},
	},
})
</script>

<template>
	<!-- @vue-ignore -->
	<line-chart
		ref="chart"
		:data="//@ts-ignore
			props.chartData"
		:options="//@ts-ignore
			chartOptions"
	/>
</template>
